const TOGGLE_STATUS = 'TOGGLE_STATUS';
const SET_STATUS = 'SET_STATUS';
const SET_NOTIFICATIONS_FOCUSED = 'SET_NOTIFICATIONS_FOCUSED';

export {
  TOGGLE_STATUS,
  SET_STATUS,
  SET_NOTIFICATIONS_FOCUSED
}
